import QuestionSeries from "@/features/Scores/QuestionSeries";
import ChangeTrackedEvent from "@/shared/models/ChangeTrackedEvent";
import User from "@/shared/models/User";

export enum ScoreStatus {
    draft,
    published,
}

export enum UIScoreStatus {
    "Draft",
    "Published",
}

export enum ScoreValueType {
    minMax,
    optionSelect,
}

export class QuestionAnswerOption {
    answer: string = "";
    value: number = 0;
}

export default class Score {
    id: string = "";
    supplierID: string = "";
    questionSeriesID: string = "";
    questionSeries: QuestionSeries = new QuestionSeries();
    createdTimestampUTC: Date = new Date();
    createdByID: string = "";
    createdBy: User = new User();
    updatedTimestampUTC: Date | null = null;
    updatedByID: string | null = null;
    updatedBy: User | null = null;
    assessmentDate: Date = new Date();
    isLocked: boolean = false;
    lockedTimestampUTC: Date | null = null;
    lockedByID: string | null = null;
    lockedBy: User | null = null;
    isSkipped: boolean = false;
    weight: number = 0;
    valueType: ScoreValueType = ScoreValueType.minMax;
    possibleAnswers: QuestionAnswerOption[] | null = null;
    answerMin: number | null = null;
    answerMax: number | null = null;
    optionSelectValue: string | null = null;
    minMaxValue: number | null = null;
    title: string = "";
    description: string = "";
    order: number = 0;
    canBeSkipped: boolean = false;
    events: ChangeTrackedEvent[] = [];
}
